/* eslint-disable jsdoc/require-jsdoc */
import { ReactElement, useState } from 'react';
import BLEDeviceSelection from '../components/BleDeviceSelection';
import WiFiCredentials from '../components/WiFiCredentials';
import Button from '../controls/Button';

interface BLEDevice {
  deviceId: string;
  name?: string;
}
export default function ConnectDevicesPage(): ReactElement {
  const [selectedDevices, setSelectedDevices] = useState<BLEDevice[]>([]);
  const [step, setStep] = useState<number>(1);

  const nextStep = (): void => setStep(step + 1);

  return (
    <div>
      {step === 1 && <BLEDeviceSelection setSelectedDevices={setSelectedDevices} />}
      {step === 2 && <WiFiCredentials selectedDevices={selectedDevices} />}
      {step === 1 && selectedDevices.length > 0 && (
        <Button name="Next" size="sm" theme="primary" className="mt-2" onClick={nextStep} />
      )}
    </div>
  );
}
